// extracted by css-extract-rspack-plugin
export default {"canceledText":"Row__canceledText--a3T7E"};